import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const nirvana = defineConnector({
  identifier: "nirvana",
  name: "Nirvana",
  tagLine: "Insurance benefits verification",
  logo,
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://coverage-api\\.meetnirvana\\.com/.*",
  protocol: "http",
  auth: (app) => headerAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Request an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Contact Nirvana via the [Get started](https://www.meetnirvana.com/get-started) page to have an API key issued for your organization.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
});
